import { configureStore } from "@reduxjs/toolkit";
import counterReducer from "../features/counter/counterSlice";

import CityReducer from "../features/AdminPanel/Address/CityList/CityListSlice";
import JobSkillsReducer from "../features/AdminPanel/JobPostingSlice/JobSkillsList/JobSkillsSlice";
import JobEducationReducer from "../features/AdminPanel/JobPostingSlice/JobEducation/JobEducationSlice";
import JobDepartmentReducer from "../features/AdminPanel/JobPostingSlice/JobDepartment/JobDepartmentSlice";
import JobCompanyReducer from "../features/AdminPanel/JobCompanyList/JobCompanyListSlice";
import JobEducationCourseReducer from "../features/AdminPanel/JobPostingSlice/JobEducationCourse/JobEducationCourceSlice";
import CandidateEducationReducer from "../features/CandProfCreation/CandidateProfileSlice/Education/EducationSlice";
import CandidateProjectReducer from "../features/CandProfCreation/CandidateProfileSlice/Project/ProjectSlice";
import ITskillsReducer from "../features/CandProfCreation/CandidateProfileSlice/ITskills/ITskillSlice";
import JobPreferenceReducer from "../features/CandProfCreation/CandidateProfileSlice/JobPreference/JobPreferenceSlice";
import CertificationsReducer from "../features/CandProfCreation/CandidateProfileSlice/Certifications/CertificationSlice";
import SavedJobReducer from "../features/candidateDashboard/candidateSlice/SavedJobs/SavedJobsSlice";
import AppliedJobReducer from "../features/candidateDashboard/candidateSlice/AppliedJobs/AppliedJobsSlice";
import CandidateExperienceReducer from "../features/CandProfCreation/CandidateProfileSlice/Experience/ExperienceSlice";
import candidateExperience2 from "../features/CandProfCreation/CandidateProfileSlice/Experience/ExperienceSlice2";
import candDashBasicDetailsReducer from "../features/profile/BasicDetailsController/BasicDetailsSlice";
import candDashBasicDetailsBySingleParam from "../features/profile/BasicDetailsSingleParam/BasicDetailsSingleParamSlice"
import candidateAboutYouReducer from "../features/CandProfCreation/CandidateProfileSlice/AboutYou/AboutSlice";
import candProfileExperiencesReducer from "../features/CandProfCreation/CandidateProfileSlice/Experience/ExperienceSlice2";

// import CompanyReviewsReducer from "../features/employerDashboard/employerDashboardSlice/employerCompanyReviews/CompanyReviewsSlice";
import JobTitlesReducer from "../features/AdminPanel/JobPostingSlice/JobTitles/JobTitlesSlice";
import CompanyListReducer from "../features/Company/CompanySlice/CompanyListSlice";
import jobsByCompanyReducer from "../features//Company/JobsByCompanySlice/JobsByCompanySlice";
import authTokenSlice from "../features/common/FetchTokenSlice";
import auth from "../features/auth/authSlices";
import publicJobListReducer from "../features/jobList/publicJobListSlice/publicJobListSlice";
import publicJobDetailReducer from "../features/jobList/publicJobDescription/publicJobDescriptionSlice";
import jobCategoryListReducer from "../features/jobCategories/JobCategorySlice/JobCategorySlice";
import candidatepublicsubscriptionReducer from "../features/CandidatePublicSubscription/CandidatePublicSubcriptionSlice"
import latestJobListReducer from "../features/jobList/LatestJobList/LatestJobListSlice";
import jobRolesReducer from "../features/JobRoles/JobRolesSlice";
import topCompaniesReducer from "../features/TopCompanies/TopCompaniesSlice";
import popularJobRolesListReducer from "../features/jobList/PopularJobRolesList/PopularJobRolesListSlice";
import popularJobCategoriesListReducer from "../features/jobList/PopularJobCategoriesList/PopularJobCategoriesListSlice";
import recommendedJobsReducer from "../features/HomeAfterLogin.js/RecommendedJobsSlice/RecommendedJobsSlice";
import candidateMostActiveRecentJobsReducer from "../features/HomeAfterLogin.js/CandidateMostActiveRecentJobs/CandidateMostActiveRecentJobSlice"
import suggestionsReducer from "../features/jobSearch/Suggestions/SuggestionsSlice";
import jobsByKeywordsReducer from "../features/jobSearch/jobSearchByKeywordSlice.js/jobSearchByKeywordSlice";
import jobSearchHistoryReducer from "../features/jobList/jobSearchHistory/jobSeachHistorySlice";
import publicCoreLocationsReducer from "../features/jobSearch/FetchLocationSlice/FetchLocationSlice";
import candidateJobHistoryReducer from "../features/jobSearch/CandidateJobSearchHistory/CandidateJobSearchHistorySlice";
import companyDetailsReducer from "../features/Company/CompanySingleSlice/CompanySingleSlice";
import testimonialsReducer from "../features/AdminPanel/Testimonials/TestimonialsSlice";
import publicCompanyReviewsReducer from "../features/Public/PublicCompanyReviews/PublicCompanyReviewsSlice";
import careerProfileReducer from "../features/HomeAfterLogin.js/CareerProfileSlice/CareerProfileSlice";
import jobEducationCourseSpecialtyReducer from "../features/AdminPanel/JobPostingSlice/JobEducationCourseSpecialty/JobEducationCourseSpecialtySlice";
import LanguageReducer from "../features/CandProfCreation/CandidateProfileSlice/Language/LanguageSlice";
import errorMiddleware from "../features/common/errorMiddleware";
import errorReducer from "../features/common/errorSlice";

import coreIndustryReducer from "../features/AdminPanel/CoreIndustry/CoreIndustrySlice";
import contactUsReducer from "../features/AdminPanel/ContactUs/ContactUsSlice"
import contactUsPublicReducer from "../features/ContactUsHome/ContactUsHomeSlice"
import SubscriptionSlice from "../features/AdminPanel/Subscriptions/SubscriptionDetails/SubscriptionSlice";
import subscriptionCustomReducer from "../features/AdminPanel/Subscriptions/SubscriptionCustom/SubscriptionCustomSlice"
import CandidateDataSlice from "../features/AdminPanel/CandidateData/CandidateDataSlice";
import EmployerDataSlice from "../features/AdminPanel/EmployerData/EmployerDataSlice";
import subscriptionTopUpReducer from "../features/AdminPanel/Subscriptions/SubscriptionTopUp/SubscriptionTopUpSlice"
import subscriptionEmployerTopUpReducer from "../features/AdminPanel/Subscriptions/SubscriptionEmployerTopUp/SubscriptionEmployerTopUpSlice"
import adminReviewsReducer from "../features/AdminPanel/AdminReviews/AdminReviewsSlice"
import adminResumeBuilderReducer from "../features/AdminPanel/AdminResumeBuilder/AdminResumeBuilderSlice"
import admindashboarddataReducer from "../features/AdminPanel/DashboardData/DashboardDataSlice"
import adminJobListReducer from "../features/AdminPanel/JobList/AdminJobListSlice"
import jobReducer from "../features/candidateDashboard/candidateSlice/RelatedJobs/RelatedJobsSlice"
import emailReducer from "../features/auth/Slice/PasswordResetRequest/PasswordResetRequestSlice"
import passwordReducer from "../features/auth/Slice/PasswordReset/PasswordResetSlice"
import changePasswordReducer from "../features/auth/Slice/PasswordChange/PasswordChangeSlice"
import emailVerificationReducer from "../features/auth/Slice/EmailVerification/EmailVerificationSlice"
import candidateSubscriptionsReducer from "../features/candidateDashboard/candidateSlice/CandidateSubscriptions/CandidateSubscriptionsSlice"
import candidateActiveSubscriptionsReducer from "../features/candidateDashboard/candidateSlice/CandidateActiveSubscription/CandidateActiveSubscriptionSlice"
import activeResumeBuilderReducer from "../features/candidateDashboard/candidateSlice/CandidateActiveResumeBuilder/CandidateActiveResumeBuilderSlice"
import CandidateTotalResumeReducer from "../features/candidateDashboard/candidateSlice/CandidateActiveResumeBuilder/CandidateResumeBuilderSlice"
import adminNotificationsReducer from "../features/AdminPanel/Notifications/NotificationsSlice"
import usersReducer from "../features/AdminPanel/Notifications/NotificationsSlice"
import JobCityReducer from "../features/AdminPanel/Address/JobCityList/JobCityListSlice"
import CountryReducer from "../features/AdminPanel/Address/CountryList/CountryListSlice"
import StateReducer from "../features/AdminPanel/Address/StateList/StateListSlice"
// import candidatebasicdetailsresumebuilderReducer from "../features/Public/PublicResume/ResumeDashboardSlice"
import checkEmailVerificationReducer from "../features/auth/Slice/EmailVerificationSignup/EmailVerificationSignupSlice"
import checkPhoneVerificationReducer from "../features/auth/Slice/PhoneVerificationSignup/PhoneVerificationSlice"
import skillDevelopmentAdminReducer from "../features/AdminPanel/SkillDevelopmentAdmin/SkillDevelopmentAdminSlice"
import InterviewPreparationAdminReducer from "../features/AdminPanel/InterviewPreparationAdmin/InterviewPreparationAdminSlice"
import skillDevelopmentReducer from "../features/candidateDashboard/candidateSlice/SkillDevelopment/SkillDevelopmentSlice"
import interviewPreparationReducer from "../features/candidateDashboard/candidateSlice/InterviewPreparation/InterviewPreparationSlice"
import careerAdviceReducer from "../features/candidateDashboard/candidateSlice/CareerAdvice/CareerAdviceSlice"
import careerAdviceAdminReducer from "../features/AdminPanel/CareerAdviceAdmin/CarrerAdviceAdminSlice"
export const store = configureStore({
  reducer: {
    auth: auth,
    counter: counterReducer,
    authTokenReducer: authTokenSlice,
    jobTitles: JobTitlesReducer,
    jobSkills: JobSkillsReducer,
    jobEducation: JobEducationReducer,
    jobDepartments: JobDepartmentReducer,
    jobCompanyList: JobCompanyReducer,
    jobEducationCourse: JobEducationCourseReducer,
    city: CityReducer,
    country: CountryReducer,
    State: StateReducer,
    jobCity: JobCityReducer,
    adminJobList: adminJobListReducer,

    coreIndustry: coreIndustryReducer,
    contactUs: contactUsReducer,
    contactUsPublic: contactUsPublicReducer,
    subscription: SubscriptionSlice,
    candidateData: CandidateDataSlice,
    employerData: EmployerDataSlice,
    adminNotifications: adminNotificationsReducer,
    users: usersReducer,
    subscriptionCustom: subscriptionCustomReducer,
    subscriptionTopUp: subscriptionTopUpReducer,
    subscriptionEmployerTopUp: subscriptionEmployerTopUpReducer,
    skillDevelopmentAdmin: skillDevelopmentAdminReducer,
    interviewPreparationAdmin: InterviewPreparationAdminReducer,
    careerAdviceAdmin: careerAdviceAdminReducer,

    testimonials: testimonialsReducer,
    adminReviews: adminReviewsReducer,
    adminResumeBuilder: adminResumeBuilderReducer,
    admindashboarddata: admindashboarddataReducer,
    jobEducationCourseSpecialty: jobEducationCourseSpecialtyReducer,

    global: errorReducer,
    email: emailReducer,
    password: passwordReducer,
    changePassword: changePasswordReducer,
    emailVerification: emailVerificationReducer,

    aboutYou: candidateAboutYouReducer,
    candidateSubscriptions: candidateSubscriptionsReducer,
    candidateActiveSubscriptions: candidateActiveSubscriptionsReducer,
    activeResumeBuilder: activeResumeBuilderReducer,
    CandidateTotalResume: CandidateTotalResumeReducer,
    candProfileBasicDetails: candDashBasicDetailsReducer,
    candProfileBasicDetailsBySingleParam: candDashBasicDetailsBySingleParam,
    // candidatebasicdetailsresumebuilder: candidatebasicdetailsresumebuilderReducer,

    candProfileExperiences: candProfileExperiencesReducer,

    candidateEducation: CandidateEducationReducer,
    candidateExperience: CandidateExperienceReducer,
    candidateExperience2: candidateExperience2,

    skillDevelopment: skillDevelopmentReducer,
    interviewPreparation: interviewPreparationReducer,
    careerAdvice: careerAdviceReducer,

    candidateProjects: CandidateProjectReducer,
    ITskills: ITskillsReducer,
    language: LanguageReducer,
    jobPreference: JobPreferenceReducer,
    certifications: CertificationsReducer,
    careerProfile: careerProfileReducer,

    candidateJobHistory: candidateJobHistoryReducer,
    jobSearchHistory: jobSearchHistoryReducer,

    companies: CompanyListReducer,
    jobsByCompany: jobsByCompanyReducer,

    savedJob: SavedJobReducer,
    appliedJob: AppliedJobReducer,
    jobs: jobReducer,

    // job details
    recommendedJobs: recommendedJobsReducer,
    candidateMostActiveRecentJobs: candidateMostActiveRecentJobsReducer,

    // public APIs
    publicJobList: publicJobListReducer,
    publicJobDetail: publicJobDetailReducer,
    latestJobList: latestJobListReducer,
    popularJobRolesList: popularJobRolesListReducer,
    popularJobCategoriesList: popularJobCategoriesListReducer,
    jobCategoryList: jobCategoryListReducer,
    candidatepublicsubscription: candidatepublicsubscriptionReducer,
    jobRoles: jobRolesReducer,
    topCompanies: topCompaniesReducer,
    suggestions: suggestionsReducer,
    jobsByKeywords: jobsByKeywordsReducer,
    publicCoreLocations: publicCoreLocationsReducer,
    companyDetails: companyDetailsReducer,
    publicCompanyReviews: publicCompanyReviewsReducer,
    emailVerificationPublic: checkEmailVerificationReducer,
    phoneVerification: checkPhoneVerificationReducer,
  },

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(errorMiddleware),
});
